export default __webpack_public_path__ + "static/media/icon3.e00eeef2.svg";